<template>
<a href="/index/selectCity.html" :class="current" :data-scp="scp">
	<i class="icon icon-position"></i><span>选择城市</span>
</a>
</template>
<script>
export default {
	props: ['current', 'scp']
};
</script>